module.exports = __webpack_public_path__ + "img/shop.858f770.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/trait/shop.png
// module id = ozUB
// module chunks = 14